<tds-modal
  header="{{ title }}"
  show
  id="modal-confirmation"
  size="sm"
  actions-position="static"
  prevent="true"
  closable="false"
>
  <span slot="body">
    {{ text }}
  </span>
  <span slot="actions" class="tds-u-flex tds-u-gap2">
    <tds-button
      (click)="action(true)"
      size="lg"
      text="{{ confirmText }}"
      variant="{{ confirmVariant }}"
    ></tds-button>
    <tds-button
      (click)="action(false)"
      size="lg"
      text="{{ cancelText }}"
      variant="{{ cancelVariant }}"
    ></tds-button>
  </span>
</tds-modal>
